<accept-modal>
    <div
            class="modal js-modal"
            is="modal-base"
            is-open="{ props.isOpen }"
            on-before-show="{ onBeforeShow }"
    >
        <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
        <div class="modal__content">
            <div class="modal__content_inner" >
                <h3 class="modal_heading margin-spacing-3_bottom">マイナンバー閲覧申請の承諾</h3>
                <p class="note" style="font-size: 1.5rem">
                    申請を承諾すると、クライアント様側で一定期間貴方のマイナンバーを閲覧できるようになります。
                </p>
                <p class="note" style="font-weight: bold;font-size: 1.5rem">
                    閲覧期限は「クライアント様がマイナンバーの閲覧を開始してから24時間」です。
                </p>

                <p class="note" style="font-size: 1.5rem">マイナンバーの閲覧を承諾しますか？</p>

                <h3 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">
                    承諾に際し、クライアント様にメッセージがある場合は以下にご記入下さい
                </h3>
                <div>
                    <input type="text"
                           name="apply_message"
                           class="text_input margin-spacing-1_bottom"
                           value="{state.reply_message}"
                           onkeyup={setReplyMessage}
                    >
                </div>

                <div class="wrap_button margin-spacing-4_top">
                    <div class="button button-secondary-large button-border margin-spacing-1_right"
                         type="button"
                         onclick="{ props.onClose }"
                    >
                        閉じる
                    </div>
                    <div
                            class="button button-secondary-large"
                            type="button"
                            value="承諾する"
                            onclick="{ accept }"
                    >
                        承諾する
                    </div>
                </div>

                <!--/.modal__content_inner-->




                <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
            </div>
            <!--modal__content-->
        </div>
        <!--modal-->
        <script>
            import di from "dependency-injection";
            import base from "../../modal-base.riot";

            export default {
                api : null,
                components: {
                    "modal-base": base,
                },
                state:{
                    reply_message:""
                },
                onBeforeMount(props, state){
                    this.api = di.createApi('menu');

                },
                onBeforeShow() {
                    //表示前に入力エリアを初期化
                    this.update({reply_message:"了解しました"});
                },
                setReplyMessage(e){
                    this.state.reply_message = e.target.value;
                },
                async accept(e){

                    const res = await this.api.request(
                        "mynumber-browsing-application",
                        "accept",
                        {
                            application_id : this.props.target_application_id,
                            reply_message : this.state.reply_message
                        }
                    );
                    this.props.onAccept();

                }
            };
        </script>
</accept-modal>
